import { useState } from 'react';
import { scheduleSelectors } from 'features/schedule/redux';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import { ScheduleReportStatus } from 'services/api';
import type { MaybeType } from 'shared/types';
import { DEFAULT_TAG, STATUS_TAGS } from '../config';

export const useTags = () => {
  const reportStatus = useAppSelector(scheduleSelectors.getReportStatus);
  const hasErrors = useAppSelector(scheduleSelectors.getHasErrors);

  const tags = reportStatus ? STATUS_TAGS[reportStatus] : hasErrors ? DEFAULT_TAG : null;

  const [violationsOpen, setViolationsOpen] = useState(false);
  const [violationsType, setViolationsType] = useState<MaybeType<ScheduleReportStatus>>(null);

  const handleOpenViolations = (type: ScheduleReportStatus) => {
    if (type !== ScheduleReportStatus.SUCCESS) {
      setViolationsOpen(true);
      setViolationsType(type);
    }
  };

  const handleCloseViolations = () => {
    setViolationsOpen(false);
    setViolationsType(null);
  };

  return {
    state: {
      tags,
      violationsOpen,
      violationsType,
    },
    methods: {
      setViolationsOpen,
      setViolationsType,
      handleCloseViolations,
      handleOpenViolations,
    },
  };
};
